<div class="section-container">
	<div class="header-container">
		<app-title-field
			[title]="'Timesheet'"
			[icon]="'time'"
			[iconVariant]="'outlined'"
		></app-title-field>
        
		<app-search-field
			[placeholder]="'Search by month'"
			[searchValues]="searchValues"
			(search)="onSearch($event)"
			(cleared)="onClear()"
		></app-search-field>
	</div>

	<app-table
		[columnDefs]="TIMESHEET_COLUMNS"
		[rowData]="filteredTimesheetData"
		[gridOptions]="gridOptions"
		[enableActions]="tableConfig.enableActions || false"
		[customActions]="customActions"
		[enablePagination]="false"
		[enableRowSelection]="tableConfig.enableRowSelection || false"
		[rowSelectionMode]="tableConfig.rowSelectionMode || 'multiple'"
		[enableSorting]="tableConfig.enableSorting ?? true"
		[enableFiltering]="tableConfig.enableFiltering ?? true"
		[enableColumnResize]="tableConfig.enableColumnResize ?? true"
		[height]="maxTableHeight"
		(cellClicked)="onCellClicked($event)"
	>
	</app-table>

	<div *ngIf="calendarOpened" class="calendar-popup" [ngStyle]="calendarPosition">
		<app-timesheet-calendar
			*ngIf="calendarOpened"
			[componentName]="componentName"
			[candidateDetails]="selectedContractor"
			[selectedyear]="year"
			[selectedmonth]="month"
			[useEmployeeTimesheet]="true"
			[employeeTimesheetData]="selectedTimesheetMonthData"
			(refreshTimesheet)="reloadTimesheetData()"
			(closeComponent)="closeCalendar()"
		></app-timesheet-calendar>
	</div>
</div>
<app-confirmation-dialog
  [isOpen]="showSubmitConfirmation"
  [title]="TIMESHEET_CONSTANTS.CONFIRMATION_DIALOG.TITLE"
  [message]="TIMESHEET_CONSTANTS.CONFIRMATION_DIALOG.MESSAGE"
  [submitLabel]="TIMESHEET_CONSTANTS.CONFIRMATION_DIALOG.SUBMIT_LABEL"
  [cancelLabel]="TIMESHEET_CONSTANTS.CONFIRMATION_DIALOG.CANCEL_LABEL"
  (confirm)="onConfirmSubmit()"
  (cancel)="onCancelSubmit()">
</app-confirmation-dialog>